import { Component } from '@angular/core';
import { PageTitleComponent } from "@shared/components/page-title/page-title.component";
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-home-controller',
  standalone: true,
  imports: [
    PageTitleComponent,
    TranslatePipe
  ],
  templateUrl: './home-controller.component.html',
  styleUrl: './home-controller.component.scss'
})
export class HomeControllerComponent {
  breadCrumbItems = [
    {
      label: 'Smart Controller',
    },
    {
      label: 'Home Controller',
      active: true,
    }
  ]
}
